import type { Dispatch, SetStateAction } from "react";
import { BaseFlex, CenteredFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { CircleSwitcherItem, Switcher } from "@similarweb/ui-components";
import { RankingDistributionSubTitle } from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/StyledComponents";
import { SWReactIcons } from "@similarweb/icons";
import { RankingDistributionMetric } from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/rankingDistribution.types";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

const RankingDistributionContainer = styled(BaseFlex)`
    padding: 12px 12px 0 24px;
    background: ${colorsPalettes.carbon[0]};
`;

type RankingDistributionCompareModePanelProps = {
    metricTitle: string;
    switchTitles: [string, string];
    metric: RankingDistributionMetric;
    setCurrentMetric: Dispatch<SetStateAction<RankingDistributionMetric>>;
};

const MAP_RANKING_DISTRIBUTION_STRING_TO_ENUM = {
    [RankingDistributionMetric.ByPosition]: RankingDistributionMetric.ByPosition,
    [RankingDistributionMetric.ByWebsite]: RankingDistributionMetric.ByWebsite,
};

export const RankingDistributionCompareModePanel = ({
    metricTitle,
    switchTitles,
    metric,
    setCurrentMetric,
}: RankingDistributionCompareModePanelProps) => {
    return (
        <RankingDistributionContainer
            alignItems={"center"}
            justifyContent={"space-between"}
        >
            <FlexRow>
                <RankingDistributionSubTitle>{metricTitle}</RankingDistributionSubTitle>
                <SWReactIcons iconName={"no-data-lab"} />
            </FlexRow>
            <CenteredFlexRow>
                <Switcher
                    selectedIndex={MAP_RANKING_DISTRIBUTION_STRING_TO_ENUM[metric]}
                    onItemClick={setCurrentMetric}
                >
                    <CircleSwitcherItem>{switchTitles[0]}</CircleSwitcherItem>
                    <CircleSwitcherItem>{switchTitles[1]}</CircleSwitcherItem>
                </Switcher>
                {/*TODO: add buttons in the second phase*/}
                {/*<ActionIconsContainer>*/}
                {/*    <SWReactIcons iconName={"excel"} size={"sm"} />*/}
                {/*    <SWReactIcons iconName={"download"} size={"sm"} />*/}
                {/*    <SWReactIcons iconName={"plus"} size={"sm"} />*/}
                {/*</ActionIconsContainer>*/}
            </CenteredFlexRow>
        </RankingDistributionContainer>
    );
};
